import { Button, Typography, Box } from '@mui/material';
import { useShippingLabelsStyles } from 'components/OrderForm/BillingShipping/styles';
import { checkIsDateOlderThanMonth } from 'utilities/dates_and_times';

export const ShippingLabelsTab = ({ shippingLabels }) => {
  const { classes } = useShippingLabelsStyles();

  return shippingLabels.map((shippingLabel) => {
    const { tracking_number, shippo_url, uuid, created } = shippingLabel;
    const isExpired = checkIsDateOlderThanMonth(created);
    const renderActionSection = () => {
      if (isExpired) {
        return (
          <Typography variant="body2" color="textSecondary">
            Shipping label expired
          </Typography>
        );
      }

      if (shippo_url) {
        return (
          <a href={shippo_url} target="_blank" rel="noopener noreferrer">
            <Button variant="contained" color="secondary" size="small">
              View Shipping Label
            </Button>
          </a>
        );
      }

      return (
        <Typography variant="body2" color="textSecondary">
          No shipping label available
        </Typography>
      );
    };

    return (
      <Box key={uuid} mb={2} className={classes.labelsTable}>
        <div>Tracking #: {tracking_number}</div>
        {renderActionSection()}
      </Box>
    );
  });
};
